import moment from "moment";
import * as Yup from "yup";
import {
	ArchiveInfoKind,
	discountActionForm_DiscountActionFragment$data,
} from "@relay/discountActionForm_DiscountActionFragment.graphql";
import { UsageLimitedInput } from "@relay/discountActionForm_EditDiscountActionMutation.graphql";
import { parseDateTime } from "../../../../components/DateTimeDisplay";

export const discountActionFormValidationSchema = ({
	isArchived,
	kind,
	oldUsage,
}: {
	isArchived: boolean;
	kind: ArchiveInfoKind;
	oldUsage: discountActionForm_DiscountActionFragment$data["usageLimitation"];
}) =>
	Yup.object().shape({
		percentage: Yup.number()
			.max(100, "Der Wert muss kleiner als 100% sein")
			.min(1, "Der Wert muss mindestens 1% sein"),

		validUntil: Yup.string()
			.nullable()
			.test(
				"validUntil should not be in the past",
				"Gültig bis darf nicht in der Vergangenheit liegen",
				(value) => {
					if (!value) return true;
					const date = parseDateTime(value);
					return date?.isValid() && date.isSameOrAfter(moment(), "minute");
				},
			),

		usageLimitation: Yup.mixed()
			.nullable()
			.test(
				"usage limitation check when reactivating an archived discount action",
				"Mindestens ein Feld muss geändert werden und Maximalwerte dürfen nicht niedriger als alte Werte sein",
				function (value) {
					if (!isArchived) return true; // applied only on reactivating archived discount actions

					if (kind !== "UsageExhausted") return true;

					if (!value) return true;

					const usage = value as UsageLimitedInput;

					const oldMax = oldUsage?.maxAmountOfUsages?.max;
					const newMax = usage.maxAmountOfUsages;

					const maxUsageValid = newMax == null || oldMax == null || newMax > oldMax;

					if (!maxUsageValid) {
						return this.createError({
							message:
								"Die maximale Anzahl an Nutzungen muss unbegrenzt oder größer als die bisherigen Werte sein.",
						});
					}

					return true;
				},
			),
	});
